import React from 'react';
// import Immutable from 'immutable';

/**
 * Check 校验方法集合
 * 需要依赖 Immutable 插件
 * @Author gufuyan
 * @Date 2019-09-20
 */
class CheckFn {
    //函数参数默认值
    constructor() {
    }

    /***
     * react shouldComponentUpdate 是否是否更新 render
     * @param propsName 调用组件的props集合
     * @returns {boolean}
     */
    getShouldComponentUpdate = (thisProps, nextProps, propsName = []) => {
        // let updateFlag = false;
        // let nextPropsItem = {}, thisPropsItem = {};
        // for (let item of propsName) {
        //     nextPropsItem = {}, thisPropsItem = {};
        //     nextPropsItem[item] = nextProps[item];
        //     thisPropsItem[item] = thisProps[item];
        //
        //     //只要有一个为false 不相等，需要渲染render，终止循环
        //     if (!Immutable.Map(nextPropsItem).equals(Immutable.Map(thisPropsItem))) {
        //         updateFlag = true;
        //         break;
        //     }
        // }
        // return updateFlag;
    };

}

let _Check = new CheckFn();

export {_Check}

